"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invitation = void 0;
const resource_model_1 = require("./resource.model");
/**
 * Table: `idea_invitations`.
 *
 * Indexes:
 *   - `email-index` (all).
 */
class Invitation extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.invitationCode = this.clean(x.invitationCode, String);
        this.teamId = this.clean(x.teamId, String);
        this.email = this.clean(x.email, String);
        this.expiresAt = this.clean(x.expiresAt, Number);
    }
    safeLoad(newData, safeData) {
        super.safeLoad(newData, safeData);
        this.invitationCode = safeData.invitationCode;
        this.teamId = safeData.teamId;
        this.email = safeData.email;
        this.expiresAt = safeData.expiresAt;
    }
}
exports.Invitation = Invitation;
